import angular, {IController, IModule, IOnChangesObject} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {AvtaleRessurs} from "felles/tjenester/ressurser/AvtaleRessurs";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {trimTilNull} from "../../../../../felles/stoettefunk/strenger";

const css = require('./redigerFaktureringsinformasjon.scss');

export class RedigerFaktureringsinformasjonKontroller implements IController {
    static registrerKomponent(angular: IModule) {
        angular
            .component('wmAvtaleRedigerFaktureringsinformasjon', {
                bindings: {avtale: '<', vedLagret: '&', vedAvbryt: '&'},
                controller: RedigerFaktureringsinformasjonKontroller.forInjisering(),
                template: require('./redigerFaktureringsinformasjon.html')
            });
    }

    static forInjisering() {
        return [
            AvtaleRessurs.regNavn,
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            RedigerFaktureringsinformasjonKontroller
        ]
    }

    constructor(private avtaleRes: AvtaleRessurs,
                private webNavigasjon: WebNavigasjon,
                private kontekst: Kontekst) {
    }

    avtale: l.AvtaledetaljerModell; //settes via bindings/$onChanges
    vedLagret: (arg: { avtale: l.AvtaledetaljerModell; }) => void; //satt via bindings
    vedAvbryt: () => void; //satt via bindings

    lagrer = false;
    modell: RedigerFakturainformasjonModell;

    viserAdressinformasjonForKopieringFunnet = false;
    viserVelgAdressinformasjonForKopiering = false;
    viserDetaljer = true;

    visAdressinformasjonForKopiering() {
        this.viserVelgAdressinformasjonForKopiering = true;
        // this.viserAdressinformasjonForKopieringFunnet = false;
        this.viserDetaljer = false;
    }

    kopierAdresseinformasjon() {
        this.viserVelgAdressinformasjonForKopiering = false;
        this.viserDetaljer = true;
        this.modell.kopierBrregAddressinformasjonTilSkjema();
    }

    avbrytVisAdressinformasjonForKopiering() {
        this.viserVelgAdressinformasjonForKopiering = false;
        this.viserDetaljer = true;
    }

    lagre() {
        this.avtaleRes.oppdaterFaktureringsinformasjon(this.modell.somSpesifikasjon()).$promise
            .then(avtale => {
                //siden vi potensielt går fra en org uten faktureringsinfo satt til med faktureringsinfo satt
                //og dette påvirker wm-proeveperiode-utloept sørger vi her for å relaste kontekst
                this.kontekst.relastBrukerOgGrupper();
                this.vedLagret({avtale: avtale});
            });
    }


    avbryt() {
        this.vedAvbryt();
    }

    $onChanges(changes: IOnChangesObject): void {
        if (changesInneholder(changes, 'avtale'))
            this.initModell()
    }

    //private hjelpemetoder

    private initModell() {
        this.modell = new RedigerFakturainformasjonModell(this.avtale, this.lastBrregInfo());
    }

    private lastBrregInfo(): angular.IPromise<l.BrregEnhet[]> {
        const promise = this.avtaleRes.finnBrregAvtaleinformasjon(this.avtale.navn).$promise;
        promise.then(brregInfo => {
            console.debug('lastBrregInfo', brregInfo);
            if (brregInfo.length > 0) this.viserAdressinformasjonForKopieringFunnet = true;
        });

        return promise;
    }
}

export class RedigerFakturainformasjonModell {
    tilgjengeligeLand: { kode: string; navn: string }[];
    spesifikasjon: RedigerFakturainformasjonSpesifikasjon;
    brregInfo: l.BrregEnhet;
    valgtBrregInfoAdresse: string;

    constructor(avtale: l.AvtaledetaljerModell, brregInfo: angular.IPromise<l.BrregEnhet[]>) {
        this.tilgjengeligeLand = _(AvtaleRessurs.landkoder())
            .toPairs()
            .map(land => ({kode: <string>land[0], navn: <string>land[1]}))
            .sortBy(land => {
                if (land.kode === 'NO') return 'AA_norge'; //sørger for at norge kommer først
                return land.navn;
            })
            .value();

        brregInfo.then(brregInfo => {
            if (brregInfo.length == 0) return;
            this.brregInfo = brregInfo[0];
            this.valgtBrregInfoAdresse = !_.isNil(this.brregInfo.forretningsadresse) ? 'forretningsadresse' : 'postadresse';
        });

        this.spesifikasjon = {
            avtaleId: avtale.id,
            organisasjonsnummer: avtale.faktureringsinformasjonAngitt ? avtale.faktureringsinformasjon.organisasjonsnummer : '',
            adresseLinje1: avtale.faktureringsinformasjonAngitt ? avtale.faktureringsinformasjon.adresseLinje1 : '',
            adresseLinje2: avtale.faktureringsinformasjonAngitt ? avtale.faktureringsinformasjon.adresseLinje2 : '',
            postnummer: avtale.faktureringsinformasjonAngitt ? avtale.faktureringsinformasjon.postnummer : '',
            poststed: avtale.faktureringsinformasjonAngitt ? avtale.faktureringsinformasjon.poststed : '',
            landkode: avtale.faktureringsinformasjonAngitt ? avtale.faktureringsinformasjon.landkode : '',
            epostadresse: avtale.faktureringsinformasjonAngitt ? avtale.faktureringsinformasjon.epostadresse : ''
        };
    }

    brregAdresselinjer(adresse: l.BrregAdresse) {
        return `${this.brregAdresselinje1(adresse)}<br>${this.brregAdresselinje2(adresse)}`;
    }

    brregAdresselinje1(adresse: l.BrregAdresse) {
        return adresse.adresse.length > 0 ? adresse.adresse[0] : '';
    }

    brregAdresselinje2(adresse: l.BrregAdresse) {
        return adresse.adresse.length > 1 ? _(adresse.adresse).tail().join(', ') : '';
    }

    kopierBrregAddressinformasjonTilSkjema() {
        const valgtAdresse = this.valgtBrregInfoAdresse === 'forretningsadresse' ? this.brregInfo.forretningsadresse : this.brregInfo.forretningsadresse;
        this.spesifikasjon.organisasjonsnummer = this.brregInfo.organisasjonsnummer;
        this.spesifikasjon.adresseLinje1 = this.brregAdresselinje1(valgtAdresse);
        this.spesifikasjon.adresseLinje2 = this.brregAdresselinje2(valgtAdresse);
        this.spesifikasjon.postnummer = valgtAdresse.postnummer;
        this.spesifikasjon.poststed = valgtAdresse.poststed;
        this.spesifikasjon.landkode = valgtAdresse.landkode;
    }

    somSpesifikasjon(): RedigerFakturainformasjonSpesifikasjon {
        this.spesifikasjon.adresseLinje2 = trimTilNull(this.spesifikasjon.adresseLinje2);
        this.spesifikasjon.organisasjonsnummer = trimTilNull(this.spesifikasjon.organisasjonsnummer);
        return this.spesifikasjon;
    }
}

export interface RedigerFakturainformasjonSpesifikasjon {
    avtaleId: string;
    organisasjonsnummer: string;
    adresseLinje1: string;
    adresseLinje2: string;
    postnummer: string;
    poststed: string;
    landkode: string;
    epostadresse: string;
}
